import React from "react";
import Image1 from "../Assets/About/About/IMG_7759.JPG";

const Section2 = () => {
  return (
    <div className="container mx-auto px-4 max-w-6xl lg:mt-20">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-8 py-8 lg:py-16">
        {/* Content Section - Full width on mobile, half on larger screens */}
        <div className="w-full lg:w-1/2 space-y-6 lg:space-y-8 px-4 order-2 lg:order-1">
          <h2 className="uppercase text-sm tracking-wider text-[#704735] font-semibold">
            Precision Meets Creativity
          </h2>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif leading-tight">
            <span className="text-gray-900">
              Transforming Digital Presence with a{" "}
            </span>
            <span className="text-[#704735] italic">
              Dentist's Eye for Detail
            </span>
          </h1>

          <p
            className="text-gray-700 text-base sm:text-lg leading-relaxed"
            style={{
              fontFamily: "Lato-Regular",
            }}
          >
            With my background as a dentist, I bring an exceptional attention to
            detail and precision to every project—just like I do when perfecting
            smiles. Connect Engage Grow was born from this very idea: combining
            precision, personalized care, and a focus on growth to make your
            brand stand out in the digital world.
          </p>

          <p
            className="text-gray-600 text-base sm:text-lg leading-relaxed"
            style={{
              fontFamily: "Lato-Regular",
            }}
          >
            I believe in the power of storytelling, bold ideas, and authentic
            connections. Every project I take on is built with care, attention
            to detail, and, yes—a splash of aesthetic magic. Think of me as your
            partner in growth, here to cheer you on, solve challenges, and
            celebrate your wins.
          </p>

          <p
            className="text-[#704735] font-medium text-base sm:text-lg italic"
            style={{
              fontFamily: "Lato-Regular",
            }}
          >
            Let's create something amazing together—you bring the vision, and
            I'll bring the magic! ✨
          </p>
        </div>

        {/* Image Section - Full width on mobile, half on larger screens */}
        <div className="w-full lg:w-1/2 relative order-1 lg:order-2">
          {/* Signature text - Adjusted positioning for different screens */}
          <div className="absolute top-4 left-4 lg:top-14 lg:-left-14 transform -rotate-12 z-20">
            <p
              className="font-handwriting text-3xl sm:text-4xl lg:text-5xl text-[#704735] animate-pulse"
              style={{
                fontFamily: "theimpressionist",
              }}
            >
              but now I know
              <br />
              how to help!
            </p>
          </div>

          {/* Image container with responsive margins and sizing */}
          <div className="w-full px-4 lg:px-0">
            <img
              src={Image1}
              alt="Woman by the window"
              className="w-full h-[400px] sm:h-[700px] lg:h-[650px] object-cover grayscale lg:ml-28 lg:-mt-[105px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
